import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ObraNavegacaoService {

  private _obraIds: number[] = [];
  private _moduloRota: string = ''; 


  setObraIds(ids: number[], moduloRota: string): void {
    this._obraIds    = [...ids];
    this._moduloRota = moduloRota;
  }

  getObraIds(): number[] {
    return this._obraIds;
  }

  getModuloRota(): string {
    return this._moduloRota;
  }

  getIndice(workID: number): number {
    return this._obraIds.indexOf(workID);
  }

  getAnterior(workID: number): number | null {
    const idx = this.getIndice(workID);
    return idx > 0 ? this._obraIds[idx - 1] : null;
  }

  getProximo(workID: number): number | null {
    const idx = this.getIndice(workID);
    return idx >= 0 && idx < this._obraIds.length - 1
      ? this._obraIds[idx + 1]
      : null;
  }

  temNavegacao(): boolean {
    return this._obraIds.length > 1;
  }
}